<template>
  <div>
    <v-card class="py-7">
      <div class="d-flex justify-space-between px-11">
        <div class="heading-2">Edit study group/event</div>
        <v-icon @click="close()">mdi-close</v-icon>
      </div>
      <div style="background: #f6f8fc" class="px-7">
        <div class="py-6">
          <div class="font-18 mb-5"><b> General information </b></div>
          <div class="slide-toggle d-flex">
            <div class="boxes" @click="form.EventLocationType = 1">
              In-Person
            </div>
            <div class="boxes" @click="form.EventLocationType = 2">Online</div>

            <div
              class="box-active animated"
              :class="{
                'presential-active': form.EventLocationType != 1 ? true : false,
              }"
            ></div>
          </div>
          <div class="mt-9">
            <span v-if="form.EventLocationType == 1">
              <v-text-field
                label="Location Title"
                v-model="form.LocationTitle"
                single-line
                dense
                :error-messages="
                  $v.form.LocationTitle.$error
                    ? 'Location title is required'
                    : null
                "
              ></v-text-field>
              <v-text-field
                class="my-8"
                label="Location Address"
                v-model="form.LocationAddress"
                single-line
                dense
                :error-messages="
                  $v.form.LocationAddress.$error
                    ? 'Location address is required'
                    : null
                "
              ></v-text-field> </span
            ><span v-if="form.EventLocationType == 2">
              <v-text-field
                label="URL Link"
                v-model="form.UrlLink"
                dense
                single-line
                :error-messages="
                  $v.form.UrlLink.$error ? 'Url Link is required' : null
                "
              ></v-text-field>
            </span>
            <v-select
              v-model="Modality"
              single-line
              dense
              class="my-8"
              :items="ModalityList"
              :menu-props="{ maxHeight: '400' }"
              label="Modality"
              attach
              multiple
              persistent-hint
              :error-messages="
                $v.Modality.$error ? 'Modality is required' : null
              "
            ></v-select>
            <v-select
              v-model="Type"
              single-line
              dense
              class="my-8"
              :items="EventTypeList"
              :menu-props="{ maxHeight: '400' }"
              label="Type"
              attach
              multiple
              persistent-hint
              :error-messages="$v.Type.$error ? 'Type is required' : null"
            ></v-select>
            <v-select
              v-model="Language"
              :items="filterLanguageList"
              dense
              :menu-props="{ maxHeight: '400' }"
              single-line
              attach
              label="Language"
              class="my-8"
              multiple
              persistent-hint
              :error-messages="
                $v.Language.$error ? 'Language is required' : null
              "
            ></v-select>
          </div>

          <div class="font-18 mb-5 mt-9"><b> Dates information </b></div>
          <div class="slide-toggle d-flex">
            <div class="boxes" @click="form.OccurrenceType = 'One-Time Event'">
              One-Time Event
            </div>
            <div class="boxes" @click="form.OccurrenceType = 'Recurring Event'">
              Recurring Event
            </div>
            <div
              class="box-active animated"
              :class="{
                'presential-active':
                  form.OccurrenceType !== 'One-Time Event' ? true : false,
              }"
            ></div>
          </div>
          <div class="mt-9">
            <v-select
              v-model="form.TimeZone"
              single-line
              dense
              class="my-8"
              :items="TimeZonesList"
              item-text="name"
              item-value="timezone"
              :menu-props="{ maxHeight: '400' }"
              label="Choose time zone"
              attach
              persistent-hint
              :error-messages="
                $v.form.TimeZone.$error ? 'Time zone is required' : null
              "
            ></v-select>
          </div>
          <!----------------------------Date time section---------------------------------------------->
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="form.OccurrenceType == 'One-Time Event'"
            >
              <v-menu
                ref="dateAt"
                attach
                :nudge-top="20"
                v-model="dateAt"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.EventDate"
                    label="Date"
                    append-icon="mdi-calendar-range-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    single-line
                    :error-messages="
                      $v.form.EventDate.$error ? 'Event date is required' : null
                    "
                  ></v-text-field>
                </template>
                <v-date-picker v-model="form.EventDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dateAt = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dateAt.save(form.EventDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-menu
                ref="time1"
                attach
                v-model="time1"
                :close-on-content-click="false"
                :nudge-top="20"
                :return-value.sync="form.TimeStart"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedStartTime"
                    label="Time Start"
                    append-icon="mdi-calendar-range-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    single-line
                    :error-messages="
                      $v.form.TimeStart.$error ? 'Time start is required' : null
                    "
                  ></v-text-field>
                </template>
                <v-time-picker v-if="time1" v-model="form.TimeStart" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="time1 = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    flat
                    color="primary"
                    @click="$refs.time1.save(form.TimeStart)"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-menu
                ref="time2"
                v-model="time2"
                :close-on-content-click="false"
                :nudge-right="-120"
                :nudge-top="20"
                attach
                :return-value.sync="form.TimeEnd"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedEndTime"
                    label="Time End"
                    append-icon="mdi-calendar-range-outline"
                    readonly
                    single-line
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="
                      $v.form.TimeEnd.$error ? 'Time end is required' : null
                    "
                  ></v-text-field>
                </template>
                <v-time-picker v-if="time2" v-model="form.TimeEnd" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="time2 = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    flat
                    color="primary"
                    @click="$refs.time2.save(form.TimeEnd)"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <!-----------------------end-----Date time section---------------------------------------------->
          <div class="mt-9" v-if="form.OccurrenceType == 'Recurring Event'">
            <div class="font-18 mb-5 mt-9"><b>Recurring Event Details</b></div>
            <v-tabs
              v-model="RecurringEventTypeTab"
              background-color="transparent"
              color="#31A754"
              class="mb-5"
            >
              <v-tab>
                <div class="text_transform">Weekly</div>
              </v-tab>
              <v-tab>
                <div class="text_transform">Monthly</div>
              </v-tab>
            </v-tabs>

            <v-tabs-items
              v-model="RecurringEventTypeTab"
              style="background: #f6f8fc"
            >
              <v-tab-item>
                <v-card color="transparent">
                  <div class="d-flex align-center mb-2">
                    Repeat every
                    <v-card outlined class="mx-1" width="60">
                      <v-text-field
                        v-model="RecurringDetails.RepeatWeekly"
                        hide-details
                        type="number"
                        solo
                        flat
                        dense
                      ></v-text-field>
                    </v-card>
                    week(s) on:
                  </div>
                  <v-row class="px-1" no-gutters>
                    <v-col
                      cols="6"
                      md="4"
                      v-for="(day, i) in WeekName"
                      :key="i"
                    >
                      <v-checkbox
                        class="ma-0 pa-0"
                        v-model="RecurringDetails.WeeklyDays"
                        multiple
                        :value="day"
                        :label="day"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <div
                    v-if="
                      $v.RecurringDetails.WeeklyDays.$error &&
                      RecurringDetails.WeeklyDays == ''
                    "
                    :class="{
                      'error-text': $v.RecurringDetails.WeeklyDays.$error,
                    }"
                  >
                    {{
                      $v.RecurringDetails.WeeklyDays.$error
                        ? "At least one day is required"
                        : null
                    }}
                  </div>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card color="transparent">
                  <div class="mb-5">Repeat this event:</div>
                  <!-- <div class="d-flex align-start">
                    <input
                      type="radio"
                      id="css"
                      style="width: 1.2rem; height: 1.2rem"
                      name="Option1"
                      value="1"
                      v-model="RecurringDetails.MonthlyRepeatType"
                    />
                    <div for="css" style="margin-top: -0.6rem">
                      <div class="d-flex align-start mb-2 ml-3">
                        Day
                        <v-card outlined class="mx-1" width="60">
                          <v-text-field
                            v-model="RecurringDetails.RepeatDay"
                            hide-details
                            type="number"
                            solo
                            flat
                            dense
                          ></v-text-field>
                        </v-card>
                        of every
                        <v-card outlined class="mx-1" width="60">
                          <v-text-field
                            v-model="RecurringDetails.RepeatMonth"
                            hide-details
                            type="number"
                            solo
                            flat
                            dense
                          ></v-text-field>
                        </v-card>
                        month(s)
                      </div>
                    </div>
                  </div> -->
                  <div class="d-flex align-start mt-2">
                    <input
                      type="radio"
                      id="css"
                      style="width: 1.2rem; height: 1.2rem"
                      name="Option1"
                      value="2"
                      v-model="RecurringDetails.MonthlyRepeatType"
                    />
                    <div for="css" style="margin-top: -0.6rem">
                      <div class="d-flex align-center mb-2 ml-3">
                        The
                        <v-card outlined class="mx-1" width="110">
                          <v-combobox
                            v-model="RecurringDetails.RepeatWeek"
                            :items="[
                              'First',
                              'Second',
                              'Third',
                              'Fourth',
                              'Last',
                            ]"
                            hide-details
                            solo
                            flat
                            dense
                          ></v-combobox>
                        </v-card>
                        <v-card outlined class="mx-1" width="110">
                          <v-combobox
                            v-model="RecurringDetails.RepeatWeekDay"
                            :items="WeekName"
                            hide-details
                            solo
                            flat
                            dense
                          ></v-combobox>
                        </v-card>
                        of every
                        <v-card outlined class="mx-1" width="60">
                          <v-text-field
                            v-model="RecurringDetails.RepeatMonth"
                            hide-details
                            type="number"
                            solo
                            flat
                            dense
                          ></v-text-field>
                        </v-card>
                        month(s)
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      $v.RecurringDetails.MonthlyRepeatType.$error &&
                      RecurringDetails.MonthlyRepeatType == null
                    "
                    :class="{
                      'error-text':
                        $v.RecurringDetails.MonthlyRepeatType.$error,
                    }"
                  >
                    {{
                      $v.RecurringDetails.MonthlyRepeatType.$error
                        ? "select the option"
                        : null
                    }}
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs-items>

            <div class="d-flex align-start mt-8">
              <input
                type="radio"
                v-model="RecurringDetails.EndOccurenceType"
                id="css"
                style="width: 1.2rem; height: 1.2rem"
                name="fav_language"
                value="1"
              />
              <div for="css" style="margin-top: -0.6rem">
                <div class="d-flex align-start mb-2 ml-3">
                  <span class="mr-2 pt-2">End after</span>
                  <v-card outlined class="mx-1" width="60">
                    <v-text-field
                      v-model="RecurringDetails.EndAfterOccurrences"
                      hide-details
                      type="number"
                      solo
                      flat
                      dense
                    ></v-text-field>
                  </v-card>
                  <span class="mr-2 pt-2">occurrence(s)</span>
                </div>
              </div>
            </div>
            <div class="d-flex align-start mt-4">
              <input
                v-model="RecurringDetails.EndOccurenceType"
                type="radio"
                id="css"
                style="width: 1.2rem; height: 1.2rem"
                name="fav_language"
                value="2"
              />
              <div for="css" style="margin-top: -0.6rem">
                <div class="d-flex align-center mb-2 ml-3">
                  <span class="pt-1 mr-2">End by</span>
                  <!-- <v-card outlined class="mx-1">
                    <input
                      type="date"
                      name=""
                      id=""
                      class="pa-1"
                      v-model="RecurringDetails.EndByDate"
                    />
                  </v-card> -->
                  <v-menu
                    ref="endByDate"
                    v-model="endByDate"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y attach
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="RecurringDetails.EndByDate"
                        label="Date"
                        append-icon="mdi-calendar-range-outline"
                        readonly dense
                        single-line
                        hide-details
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="RecurringDetails.EndByDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="endByDate = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.endByDate.save(RecurringDetails.EndByDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </div>
            </div>
            <div
              v-if="
                $v.RecurringDetails.EndOccurenceType.$error &&
                RecurringDetails.EndOccurenceType == null
              "
              :class="{
                'error-text': $v.RecurringDetails.EndOccurenceType.$error,
              }"
            >
              {{
                $v.RecurringDetails.EndOccurenceType.$error
                  ? "One option is required"
                  : null
              }}
            </div>
          </div>
          <div class="font-18 mb-5 mt-9"><b>Host Contact Details</b></div>
          <v-text-field
            label="Name"
            hide-details
            v-model="form.HostName"
          ></v-text-field>
          <v-text-field
            label="Email"
            hide-details
            v-model="form.HostEmail"
          ></v-text-field>
          <v-text-field
            label="Phone Number (optional)"
            v-model="form.HostPhoneNumber"
            hide-details
          ></v-text-field>
          <div class="mt-3"><b>Description</b></div>
          <v-textarea
            name="input-7-1"
            v-model="form.Description"
            class="mb-5"
            label=""
            counter="500"
            maxlength="500"
          ></v-textarea>
        </div>
      </div>

      <div class="px-11">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#646464"
            outlined
            depressed
            class="px-5"
            text
            @click="close()"
          >
            <span class="text_transform"> Cancel </span>
          </v-btn>
          <v-btn
            color="primary"
            class="px-8 ml-2"
            @click="saveData()"
            :disabled="btnloader"
            depressed
          >
            <span class="text_transform px-9" v-if="btnloader != true">
              Save
            </span>
            <v-progress-circular
              indeterminate
              size="20"
              v-else
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  name: "EditStudyGroupAndEventComponent",
  props: ["setDataStudyGroup"],
  computed: {
    formattedStartTime() {
      return this.formattedTime(this.form.TimeStart);
    },
    formattedEndTime() {
      return this.formattedTime(this.form.TimeEnd);
    },
    formattedTime() {
      return (timeValue) => {
        if (!timeValue) return null;

        const [hours, minutes] = timeValue.split(":");
        const date = new Date(2000, 0, 1, parseInt(hours), parseInt(minutes));
        const formatted = date.toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
        return formatted.replace(/(\d+:\d+)\s([APMapm]{2})/, "$1 $2");
      };
    },
  },
  data() {
    return {
      WeekName: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      // Recurring_Event_tab: null,
      dateAt: false,
      // StartTime: null,
      time1: false,
      // EndTime: null,
      // RecurrentEvent: "Meets on the 1st Wednesday of every month at 7:30pm...",
      time2: false,
      Presential: false,
      Modality: [],
      Type: [],
      Language: [],
      // OneTimeEvent: false,
      filterLanguageList: [
        "English",
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
      ModalityList: [
        "Open",
        "Access",
        "BodyTalk",
        "BodyTalk for Animals",
        "BreakThrough",
        "MindScape",
        "FreeFall",
        "PaRama",
      ],
      TimeZonesList: [
        {
          name: "(GMT-11:00) Midway Island",
          timezone: "Pacific/Midway",
        },
        {
          name: "(GMT-11:00) Samoa",
          timezone: "US/Samoa",
        },
        {
          name: "(GMT-10:00) Hawaii",
          timezone: "US/Hawaii",
        },
        {
          name: "(GMT-09:00) Alaska",
          timezone: "US/Alaska",
        },
        {
          name: "(GMT-08:00) Pacific Time (US & Canada)",
          timezone: "US/Pacific",
        },
        {
          name: "(GMT-08:00) Tijuana",
          timezone: "America/Tijuana",
        },
        {
          name: "(GMT-07:00) Arizona",
          timezone: "US/Arizona",
        },
        {
          name: "(GMT-07:00) Mountain Time (US & Canada)",
          timezone: "US/Mountain",
        },
        {
          name: "(GMT-07:00) Chihuahua",
          timezone: "America/Chihuahua",
        },
        {
          name: "(GMT-07:00) Mazatlan",
          timezone: "America/Mazatlan",
        },
        {
          name: "(GMT-06:00) Mexico City",
          timezone: "America/Mexico_City",
        },
        {
          name: "(GMT-06:00) Monterrey",
          timezone: "America/Monterrey",
        },
        {
          name: "(GMT-06:00) Saskatchewan",
          timezone: "Canada/Saskatchewan",
        },
        {
          name: "(GMT-06:00) Central Time (US & Canada)",
          timezone: "US/Central",
        },
        {
          name: "(GMT-05:00) Eastern Time (US & Canada)",
          timezone: "US/Eastern",
        },
        {
          name: "(GMT-05:00) Indiana (East)",
          timezone: "US/East-Indiana",
        },
        {
          name: "(GMT-05:00) Bogota",
          timezone: "America/Bogota",
        },
        {
          name: "(GMT-05:00) Lima",
          timezone: "America/Lima",
        },
        {
          name: "(GMT-04:30) Caracas",
          timezone: "America/Caracas",
        },
        {
          name: "(GMT-04:00) Atlantic Time (Canada)",
          timezone: "Canada/Atlantic",
        },
        {
          name: "(GMT-04:00) La Paz",
          timezone: "America/La_Paz",
        },
        {
          name: "(GMT-04:00) Santiago",
          timezone: "America/Santiago",
        },
        {
          name: "(GMT-03:30) Newfoundland",
          timezone: "Canada/Newfoundland",
        },
        {
          name: "(GMT-03:00) Buenos Aires",
          timezone: "America/Buenos_Aires",
        },
        {
          name: "(GMT-03:00) Greenland",
          timezone: "Greenland",
        },
        {
          name: "(GMT-02:00) Stanley",
          timezone: "Atlantic/Stanley",
        },
        {
          name: "(GMT-01:00) Azores",
          timezone: "Atlantic/Azores",
        },
        {
          name: "(GMT-01:00) Cape Verde Is.",
          timezone: "Atlantic/Cape_Verde",
        },
        {
          name: "(GMT) Casablanca",
          timezone: "Africa/Casablanca",
        },
        {
          name: "(GMT) Dublin",
          timezone: "Europe/Dublin",
        },
        {
          name: "(GMT) Lisbon",
          timezone: "Europe/Lisbon",
        },
        {
          name: "(GMT) London",
          timezone: "Europe/London",
        },
        {
          name: "(GMT) Monrovia",
          timezone: "Africa/Monrovia",
        },
        {
          name: "(GMT+01:00) Amsterdam",
          timezone: "Europe/Amsterdam",
        },
        {
          name: "(GMT+01:00) Belgrade",
          timezone: "Europe/Belgrade",
        },
        {
          name: "(GMT+01:00) Berlin",
          timezone: "Europe/Berlin",
        },
        {
          name: "(GMT+01:00) Bratislava",
          timezone: "Europe/Bratislava",
        },
        {
          name: "(GMT+01:00) Brussels",
          timezone: "Europe/Brussels",
        },
        {
          name: "(GMT+01:00) Budapest",
          timezone: "Europe/Budapest",
        },
        {
          name: "(GMT+01:00) Copenhagen",
          timezone: "Europe/Copenhagen",
        },
        {
          name: "(GMT+01:00) Ljubljana",
          timezone: "Europe/Ljubljana",
        },
        {
          name: "(GMT+01:00) Madrid",
          timezone: "Europe/Madrid",
        },
        {
          name: "(GMT+01:00) Paris",
          timezone: "Europe/Paris",
        },
        {
          name: "(GMT+01:00) Prague",
          timezone: "Europe/Prague",
        },
        {
          name: "(GMT+01:00) Rome",
          timezone: "Europe/Rome",
        },
        {
          name: "(GMT+01:00) Sarajevo",
          timezone: "Europe/Sarajevo",
        },
        {
          name: "(GMT+01:00) Skopje",
          timezone: "Europe/Skopje",
        },
        {
          name: "(GMT+01:00) Stockholm",
          timezone: "Europe/Stockholm",
        },
        {
          name: "(GMT+01:00) Vienna",
          timezone: "Europe/Vienna",
        },
        {
          name: "(GMT+01:00) Warsaw",
          timezone: "Europe/Warsaw",
        },
        {
          name: "(GMT+01:00) Zagreb",
          timezone: "Europe/Zagreb",
        },
        {
          name: "(GMT+02:00) Athens",
          timezone: "Europe/Athens",
        },
        {
          name: "(GMT+02:00) Bucharest",
          timezone: "Europe/Bucharest",
        },
        {
          name: "(GMT+02:00) Cairo",
          timezone: "Africa/Cairo",
        },
        {
          name: "(GMT+02:00) Harare",
          timezone: "Africa/Harare",
        },
        {
          name: "(GMT+02:00) Helsinki",
          timezone: "Europe/Helsinki",
        },
        {
          name: "(GMT+02:00) Istanbul",
          timezone: "Europe/Istanbul",
        },
        {
          name: "(GMT+02:00) Jerusalem",
          timezone: "Asia/Jerusalem",
        },
        {
          name: "(GMT+02:00) Kyiv",
          timezone: "Europe/Kiev",
        },
        {
          name: "(GMT+02:00) Minsk",
          timezone: "Europe/Minsk",
        },
        {
          name: "(GMT+02:00) Riga",
          timezone: "Europe/Riga",
        },
        {
          name: "(GMT+02:00) Sofia",
          timezone: "Europe/Sofia",
        },
        {
          name: "(GMT+02:00) Tallinn",
          timezone: "Europe/Tallinn",
        },
        {
          name: "(GMT+02:00) Vilnius",
          timezone: "Europe/Vilnius",
        },
        {
          name: "(GMT+03:00) Baghdad",
          timezone: "Asia/Baghdad",
        },
        {
          name: "(GMT+03:00) Kuwait",
          timezone: "Asia/Kuwait",
        },
        {
          name: "(GMT+03:00) Nairobi",
          timezone: "Africa/Nairobi",
        },
        {
          name: "(GMT+03:00) Riyadh",
          timezone: "Asia/Riyadh",
        },
        {
          name: "(GMT+03:00) Moscow",
          timezone: "Europe/Moscow",
        },
        {
          name: "(GMT+03:30) Tehran",
          timezone: "Asia/Tehran",
        },
        {
          name: "(GMT+04:00) Baku",
          timezone: "Asia/Baku",
        },
        {
          name: "(GMT+04:00) Volgograd",
          timezone: "Europe/Volgograd",
        },
        {
          name: "(GMT+04:00) Muscat",
          timezone: "Asia/Muscat",
        },
        {
          name: "(GMT+04:00) Tbilisi",
          timezone: "Asia/Tbilisi",
        },
        {
          name: "(GMT+04:00) Yerevan",
          timezone: "Asia/Yerevan",
        },
        {
          name: "(GMT+04:30) Kabul",
          timezone: "Asia/Kabul",
        },
        {
          name: "(GMT+05:00) Karachi",
          timezone: "Asia/Karachi",
        },
        {
          name: "(GMT+05:00) Tashkent",
          timezone: "Asia/Tashkent",
        },
        {
          name: "(GMT+05:30) Kolkata",
          timezone: "Asia/Kolkata",
        },
        {
          name: "(GMT+05:45) Kathmandu",
          timezone: "Asia/Kathmandu",
        },
        {
          name: "(GMT+06:00) Ekaterinburg",
          timezone: "Asia/Yekaterinburg",
        },
        {
          name: "(GMT+06:00) Almaty",
          timezone: "Asia/Almaty",
        },
        {
          name: "(GMT+06:00) Dhaka",
          timezone: "Asia/Dhaka",
        },
        {
          name: "(GMT+07:00) Novosibirsk",
          timezone: "Asia/Novosibirsk",
        },
        {
          name: "(GMT+07:00) Bangkok",
          timezone: "Asia/Bangkok",
        },
        {
          name: "(GMT+07:00) Jakarta",
          timezone: "Asia/Jakarta",
        },
        {
          name: "(GMT+08:00) Krasnoyarsk",
          timezone: "Asia/Krasnoyarsk",
        },
        {
          name: "(GMT+08:00) Chongqing",
          timezone: "Asia/Chongqing",
        },
        {
          name: "(GMT+08:00) Hong Kong",
          timezone: "Asia/Hong_Kong",
        },
        {
          name: "(GMT+08:00) Kuala Lumpur",
          timezone: "Asia/Kuala_Lumpur",
        },
        {
          name: "(GMT+08:00) Perth",
          timezone: "Australia/Perth",
        },
        {
          name: "(GMT+08:00) Singapore",
          timezone: "Asia/Singapore",
        },
        {
          name: "(GMT+08:00) Taipei",
          timezone: "Asia/Taipei",
        },
        {
          name: "(GMT+08:00) Ulaan Bataar",
          timezone: "Asia/Ulaanbaatar",
        },
        {
          name: "(GMT+08:00) Urumqi",
          timezone: "Asia/Urumqi",
        },
        {
          name: "(GMT+09:00) Irkutsk",
          timezone: "Asia/Irkutsk",
        },
        {
          name: "(GMT+09:00) Seoul",
          timezone: "Asia/Seoul",
        },
        {
          name: "(GMT+09:00) Tokyo",
          timezone: "Asia/Tokyo",
        },
        {
          name: "(GMT+09:30) Adelaide",
          timezone: "Australia/Adelaide",
        },
        {
          name: "(GMT+09:30) Darwin",
          timezone: "Australia/Darwin",
        },
        {
          name: "(GMT+10:00) Yakutsk",
          timezone: "Asia/Yakutsk",
        },
        {
          name: "(GMT+10:00) Brisbane",
          timezone: "Australia/Brisbane",
        },
        {
          name: "(GMT+10:00) Canberra",
          timezone: "Australia/Canberra",
        },
        {
          name: "(GMT+10:00) Guam",
          timezone: "Pacific/Guam",
        },
        {
          name: "(GMT+10:00) Hobart",
          timezone: "Australia/Hobart",
        },
        {
          name: "(GMT+10:00) Melbourne",
          timezone: "Australia/Melbourne",
        },
        {
          name: "(GMT+10:00) Port Moresby",
          timezone: "Pacific/Port_Moresby",
        },
        {
          name: "(GMT+10:00) Sydney",
          timezone: "Australia/Sydney",
        },
        {
          name: "(GMT+11:00) Vladivostok",
          timezone: "Asia/Vladivostok",
        },
        {
          name: "(GMT+12:00) Magadan",
          timezone: "Asia/Magadan",
        },
        {
          name: "(GMT+12:00) Auckland",
          timezone: "Pacific/Auckland",
        },
        {
          name: "(GMT+12:00) Fiji",
          timezone: "Pacific/Fiji",
        },
      ],
      EventTypeList: ["Study Group","Get-together", "Public Talk", "Expo", "Other Event"],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      RecurringEventTypeTab: null,
      RecurringDetails:
        this.setDataStudyGroup.RecurringDetails != null
          ? {
              // RecurringEventType: this.setDataStudyGroup.RecurringDetails.RecurringEventType,
              MonthlyRepeatType:
                this.setDataStudyGroup.RecurringDetails.MonthlyRepeatType,
              RepeatDay: this.setDataStudyGroup.RecurringDetails.RepeatDay,
              RepeatWeek: this.setDataStudyGroup.RecurringDetails.RepeatWeek,
              RepeatWeekDay:
                this.setDataStudyGroup.RecurringDetails.RepeatWeekDay,
              RepeatMonth: this.setDataStudyGroup.RecurringDetails.RepeatMonth,
              RepeatWeekly:
                this.setDataStudyGroup.RecurringDetails.RepeatWeekly,
              WeeklyDays: [],
              EndOccurenceType:
                this.setDataStudyGroup.RecurringDetails.EndOccurenceType,
              EndAfterOccurrences:
                this.setDataStudyGroup.RecurringDetails.EndAfterOccurrences,
              EndByDate: this.setDataStudyGroup.RecurringDetails.EndByDate?.split("T")[0],
              CreatedBy: 0,
              CreatedDate: "",
              ModifiedBy: 0,
              ModifiedDate: "",
            }
          : {
              MonthlyRepeatType: null,
              RepeatDay: null,
              RepeatWeek: null,
              RepeatWeekDay: null,
              RepeatMonth: null,
              RepeatWeekly: null,
              WeeklyDays: "",
              EndOccurenceType: null,
              EndAfterOccurrences: null,
              EndByDate: null,
              CreatedBy: 0,
              CreatedDate: "",
              ModifiedBy: 0,
              ModifiedDate: "",
            },
      form: {
        Id: this.setDataStudyGroup.Id,
        EventLocationType: this.setDataStudyGroup.EventLocationType,
        LocationTitle: this.setDataStudyGroup.LocationTitle,
        LocationAddress: this.setDataStudyGroup.LocationAddress,
        Modality: "",
        OccurrenceType: this.setDataStudyGroup.OccurrenceType,
        Type: "",
        Language: "",
        RecurringDetails: {},
        EventDate:
          this.setDataStudyGroup.EventDate != null
            ? this.setDataStudyGroup.EventDate.split("T")[0]
            : null,
        TimeZone: this.setDataStudyGroup.TimeZone,
        TimeStart:
          this.setDataStudyGroup.TimeStart != null
            ? this.setDataStudyGroup.TimeStart.split("T")[1]
            : null,
        TimeEnd:
          this.setDataStudyGroup.TimeEnd != null
            ? this.setDataStudyGroup.TimeEnd.split("T")[1]
            : null,
        HostName: this.setDataStudyGroup.HostName,
        HostEmail: this.setDataStudyGroup.HostEmail,
        HostPhoneNumber: this.setDataStudyGroup.HostPhoneNumber,
        Description: this.setDataStudyGroup.Description,
        UrlLink: this.setDataStudyGroup.UrlLink,
        CreatedBy: 0,
      },
    };
  },
  validations: {
    form: {
      LocationTitle: {
        required,
      },
      LocationAddress: {
        required,
      },
      UrlLink: {
        required,
      },
      EventDate: {
        required,
      },
      TimeStart: {
        required,
      },
      TimeEnd: {
        required,
      },
      TimeZone: {
        required,
      },
    },
    RecurringDetails: {
      EndOccurenceType: {
        required,
      },
      WeeklyDays: {
        required,
      },
      MonthlyRepeatType: {
        required,
      },
    },
    Modality: {
      required,
    },
    Language: {
      required,
    },
    Type: {
      required,
    },
  },
  mounted() {
    this.Language = this.setDataStudyGroup.Language.split(",");
    this.Modality = this.setDataStudyGroup.Modality.split(",");
    this.Type = this.setDataStudyGroup.Type.split(",");
    // this.RecurringDetails.WeeklyDays = this.setDataStudyGroup.RecurringDetails.WeeklyDays.split(",")
    if (this.setDataStudyGroup.OccurrenceType == "Recurring Event") {
      this.RecurringEventTypeTab =
        this.setDataStudyGroup.RecurringDetails.RecurringEventType == "Weekly"
          ? 0
          : 1;
      this.RecurringDetails.WeeklyDays =
        this.setDataStudyGroup.RecurringDetails.WeeklyDays.split(",");
    }
  },
  methods: {
    saveData() {
      if (this.form.OccurrenceType === "One-Time Event") {
        this.$v.form.EventDate.$touch();
        this.$v.form.TimeStart.$touch();
        this.$v.form.TimeEnd.$touch();
        this.$v.form.TimeZone.$touch();
        this.$v.Modality.$touch();
        this.$v.Language.$touch();
        this.$v.Type.$touch();
        this.submitStatus = true;
        if (this.form.EventLocationType === 1) {
          this.$v.form.LocationTitle.$touch();
          this.$v.form.LocationAddress.$touch();
          this.submitStatus = true;
          if (
            this.$v.form.LocationTitle.$invalid ||
            this.$v.form.LocationAddress.$invalid ||
            this.$v.form.TimeEnd.$invalid ||
            this.$v.form.TimeStart.$invalid ||
            this.$v.form.EventDate.invalid ||
            this.$v.Modality.invalid ||
            this.$v.Type.invalid ||
            this.$v.Language.invalid ||
            this.$v.form.TimeZone.$invalid
          ) {
            this.submitStatus = false;
          }
        }
        if (this.form.EventLocationType === 2) {
          this.$v.form.UrlLink.$touch();
          this.submitStatus = true;
          if (
            this.$v.form.UrlLink.$invalid ||
            this.$v.form.TimeEnd.$invalid ||
            this.$v.form.TimeStart.$invalid ||
            this.$v.form.EventDate.invalid ||
            this.$v.Modality.invalid ||
            this.$v.Type.invalid ||
            this.$v.Language.invalid ||
            this.$v.form.TimeZone.$invalid
          ) {
            this.submitStatus = false;
          }
        }
      }
      if (this.form.OccurrenceType === "Recurring Event") {
        this.$v.form.TimeStart.$touch();
        this.$v.form.TimeEnd.$touch();
        this.$v.RecurringDetails.EndOccurenceType.$touch();
        this.$v.form.TimeZone.$touch();
        this.$v.Modality.$touch();
        this.$v.Language.$touch();
        this.$v.Type.$touch();
        this.submitStatus = true;
        if (this.form.EventLocationType === 1) {
          this.$v.form.LocationTitle.$touch();
          this.$v.form.LocationAddress.$touch();
          this.submitStatus = true;
          if (this.RecurringEventTypeTab == 0) {
            this.$v.RecurringDetails.WeeklyDays.$touch();
            this.submitStatus = true;
            if (
              this.$v.RecurringDetails.EndOccurenceType.$invalid ||
              this.$v.RecurringDetails.WeeklyDays.$invalid ||
              this.$v.form.LocationTitle.$invalid ||
              this.$v.form.LocationAddress.$invalid ||
              this.$v.Modality.invalid ||
              this.$v.Type.invalid ||
              this.$v.Language.invalid ||
              this.$v.form.TimeZone.$invalid ||
              this.$v.form.TimeEnd.$invalid ||
              this.$v.form.TimeStart.$invalid
            ) {
              this.submitStatus = false;
            }
          }
          if (this.RecurringEventTypeTab == 1) {
            this.$v.RecurringDetails.MonthlyRepeatType.$touch();
            this.submitStatus = true;
            if (
              this.$v.RecurringDetails.EndOccurenceType.$invalid ||
              this.$v.RecurringDetails.MonthlyRepeatType.$invalid ||
              this.$v.form.LocationTitle.$invalid ||
              this.$v.form.LocationAddress.$invalid ||
              this.$v.Modality.invalid ||
              this.$v.Type.invalid ||
              this.$v.Language.invalid ||
              this.$v.form.TimeZone.$invalid ||
              this.$v.form.TimeEnd.$invalid ||
              this.$v.form.TimeStart.$invalid
            ) {
              this.submitStatus = false;
            }
          }
        }
        if (this.form.EventLocationType === 2) {
          this.$v.form.UrlLink.$touch();
          this.submitStatus = true;
          if (this.RecurringEventTypeTab == 0) {
            this.$v.RecurringDetails.WeeklyDays.$touch();
            this.submitStatus = true;
            if (
              this.$v.RecurringDetails.EndOccurenceType.$invalid ||
              this.$v.RecurringDetails.WeeklyDays.$invalid ||
              this.$v.form.UrlLink.$invalid ||
              this.$v.Modality.invalid ||
              this.$v.Type.invalid ||
              this.$v.Language.invalid ||
              this.$v.form.TimeZone.$invalid
            ) {
              this.submitStatus = false;
            }
          }
          if (this.RecurringEventTypeTab == 1) {
            this.$v.RecurringDetails.MonthlyRepeatType.$touch();
            this.submitStatus = true;
            if (
              this.$v.RecurringDetails.EndOccurenceType.$invalid ||
              this.$v.RecurringDetails.MonthlyRepeatType.$invalid ||
              this.$v.form.UrlLink.$invalid ||
              this.$v.Modality.invalid ||
              this.$v.Type.invalid ||
              this.$v.Language.invalid ||
              this.$v.form.TimeZone.$invalid
            ) {
              this.submitStatus = false;
            }
          }
        }
      }
      if (this.submitStatus) {
        this.form.CreatedBy = this.setDataStudyGroup.CreatedBy;
        if (this.form.EventLocationType == 1) {
          this.form.UrlLink = null;
        } else {
          this.form.LocationTitle = null;
          this.form.LocationAddress = null;
        }
        if (this.form.OccurrenceType == "One-Time Event") {
          delete this.form.RecurringDetails;
          if (this.setDataStudyGroup.RecurringDetails != null) {
            this.RecurringDetails.MonthlyRepeatType = null;
            this.RecurringDetails.RepeatDay = null;
            this.RecurringDetails.RepeatWeek = null;
            this.RecurringDetails.RepeatWeekDay = null;
            this.RecurringDetails.RepeatMonth = null;
            this.RecurringDetails.RepeatWeekly = null;
            this.RecurringDetails.WeeklyDays = "";
            this.RecurringDetails.EndOccurenceType = null;
            this.RecurringDetails.EndAfterOccurrences = null;
            this.RecurringDetails.EndByDate = null;
          }
        } else {
          this.form.RecurringDetails = this.RecurringDetails;
          this.form.RecurringDetails.CreatedBy =
            this.setDataStudyGroup.CreatedBy;
          if (
            this.form.RecurringDetails &&
            this.form.RecurringDetails.WeeklyDays
          ) {
            this.form.RecurringDetails.WeeklyDays =
              this.form.RecurringDetails.WeeklyDays.toString();
          }
          this.form.EventDate = null;
          if (this.RecurringEventTypeTab == 0) {
            this.RecurringDetails.RecurringEventType = "Weekly";
          } else {
            this.RecurringDetails.RepeatWeekly = null;
            this.RecurringDetails.RecurringEventType = "Monthly";
          }
        }
        this.form.Modality = this.Modality.toString();
        this.form.Type = this.Type.toString();
        this.form.Language = this.Language.toString();
        this.btnloader=true;
        this.$store.dispatch("EditEventAndGroup", this.form).then(() => {
          this.$emit("close");
          this.btnloader=false;
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Edited Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
        });
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.slide-toggle {
  position: relative;
  background-color: #e2e3ed;
  border-radius: 200px;
  width: 100%;
  margin: auto;
}
.boxes {
  width: 50%;
  height: 47px;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
  text-align: center;
  border-radius: 200px;
}

.box-active {
  position: absolute;
  width: 50%;
  height: 41px;
  top: 3px;
  left: 1%;
  right: 0;
  z-index: 1;
  background-color: white;

  border-radius: 200px;
}
.presential-active {
  right: 0;
  left: 49% !important;
}
.error-text {
  color: red;
}
</style>
